/* eslint-disable camelcase */
import React from "react";
import ReactDOM from "react-dom";

import { SearchProvider } from "@elastic/react-search-ui";

import searchConnector from "../config/searchConnector";
import azureSearchSettings from "../config/azureSearchSettings";

import SearchResultsPage from "../components/SearchResultsPage/SearchResultsPage";

import nameOfSearch from "../constants/nameOfSearch";

const searchConfig = {
  debug: false,
  apiConnector: searchConnector,
  initialState: {
    resultsPerPage: 10,
    sortField: {
      name: "Most Popular",
      value: "ga_counter",
      direction: "desc",
    },
  },
  autocompleteQuery: {
    suggestions: {
      filters: [
        {
          field: "type",
          type: "any",
          values: ["Capabilities", "Solutions"],
        },
      ],
      top: 5,
    },
  },
  searchQuery: {
    // For each particular search page we may have individual set of facets.
    // Valid facet config properties you can find here:
    // https://docs.microsoft.com/en-us/rest/api/searchservice/search-documents#facetstring-zero-or-more
    // removed business_segments: { count: 30 }
    facets: {
      domains: { count: 30 },
      industries: { count: 30 },
      locations: { count: 30 },
      topical_areas: { count: 60 },
    },
    filters: [
      {
        field: "type",
        type: "any",
        values: ["Capabilities", "Solutions"],
      },
    ],
  },
  alwaysSearchOnInitialLoad: true,
  onSearch: (state, queryConfig, next) => {
    const defaultSort = {
      value: "top_position",
      direction: "desc",
    };

    // For multiple sort, one by default second from select.
    const sortField = { ...state.sortField, default: defaultSort };

    const newState = {
      ...state,
      ...(state.sortField && { sortField }),
    };

    return next(newState, queryConfig);
  },
};

// Sorting options should be set directly for each sorter component
// and taken from the available for sorting Azure search fields.
// see Azure search definition: https://ffwagency.atlassian.net/wiki/spaces/L3HAR/pages/1821082063/Microsoft+Azure+Search
const sortOptions = [
  {
    name: "Most Popular",
    value: "ga_counter",
    direction: "desc",
  },
  {
    name: "A-Z",
    value: "title_lowercase",
    direction: "asc",
  },
  {
    name: "Relevance",
    value: "",
    direction: "",
  },
];

// Incase we have individual set of facets
// we should configure widget for each.
// https://github.com/elastic/search-ui/blob/master/ADVANCED.md#facet
const facetsConfig = {
  domains: {
    label: "Domains",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 1,
    labelsWeight: azureSearchSettings.facetLabelsWeight.domains,
  },
  industries: {
    label: "Industries",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 2,
    labelsWeight: azureSearchSettings.facetLabelsWeight.industries,
  },
  locations: {
    label: "Locations",
    filterType: "all",
    view: "SingleSelectFacet",
    weight: 3,
  },
  topical_areas: {
    label: "Solutions",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 4,
    labelsWeight: azureSearchSettings.facetLabelsWeight.topical_area,
    showMore: {
      initialShowings: 7,
    },
  },
  business_segments: {
    label: "Business Segments",
    filterType: "any",
    view: "MultiCheckboxFacet",
    weight: 5,
    labelsWeight: azureSearchSettings.facetLabelsWeight.segments_sectors,
  },
};

const resetSorting = {
  initialSort: {
    name: "Relevance",
    value: "",
    direction: "",
  },
};

const listingPageHero = {
  props: {
    title: "Capabilities",
    theme: "default",
    searchForm: true,
  },
  formConfig: {
    inputPlaceholder: "Search integrated ISR, unmanned systems, etc.",
    inputName: "search-hero-search",
    inputId: "search-hero-search",
  },
};

export default function ProductSearchResultsPageContainer() {
  return ReactDOM.createPortal(
    <SearchProvider config={searchConfig}>
      <SearchResultsPage
        sortOptions={sortOptions}
        facetsConfig={facetsConfig}
        listingPageHero={listingPageHero}
        resultListTitle="Capabilities"
        typeOfSearch={nameOfSearch.product}
        resetSorting={resetSorting}
        showTags
      />
    </SearchProvider>,
    document.getElementById("ProductSearchResultsPageComponent")
  );
}
